"use client";

import { usePathname } from "next/navigation";
import type { ReactNode } from "react";

/**
 * Renderiza children solo si la ruta NO está dentro del Portal Contabilidad.
 * Útil para widgets globales (Caonabo, OnboardingTour, etc.) que no deben
 * aparecer en el portal aislado.
 */
export default function PortalRouteGate({ children }: { children: ReactNode }) {
  const pathname = usePathname();
  if (pathname?.startsWith("/portal-contabilidad")) return null;
  if (pathname?.startsWith("/tienda")) return null;
  if (pathname?.startsWith("/conuco")) return null;
  return <>{children}</>;
}
